export default __webpack_public_path__ + "static/media/incorrect-relative.bfdccfb4.svg";